export const cuotasUruguay = {
	visa: 10,
	master: 12,
	oca: 6,
	amex: 6,
};
